import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// ── عميل API مستقل تماماً عن api.js (المستخدم للمستخدم العادي) ─────────────
// جلسة مالك المنصة (sa_token) منفصلة كلياً عن جلسة المستخدم/الموزع، ولا
// يوجد نظام refresh token لها بالباك اند (superAdminAuth.js يتحقق من JWT
// صالح لمدة 30 يوم مباشرة) — فعند انتهائها أو رفضها، تسجيل خروج فوري بدل
// محاولة تجديد.
const superAdminApi = axios.create({
  baseURL: `${API_URL}/api/superadmin`,
  timeout: 30000,
});

superAdminApi.interceptors.request.use(config => {
  if (!navigator.onLine) {
    return Promise.reject({ userMessage: 'تعذر الاتصال — تأكد من اتصالك بالشبكه' });
  }
  const token = localStorage.getItem('sa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

superAdminApi.interceptors.response.use(
  res => res,
  err => {
    if (!err.response) {
      err.userMessage = 'تعذر الاتصال — تأكد من اتصالك بالإنترنت';
      return Promise.reject(err);
    }

    const isLoginEndpoint = (err.config?.url || '').includes('/login');
    if ((err.response.status === 401 || err.response.status === 403) && !isLoginEndpoint) {
      localStorage.removeItem('sa_token');
      window.location.href = '/superadmin/login';
    }
    return Promise.reject(err);
  }
);

export default superAdminApi;
